module.exports = __webpack_public_path__ + "img/ic_drawer_2_checked.23860a4d.svg";